import {
	index,
	integer,
	jsonb,
	pgTable,
	text,
	timestamp,
	uniqueIndex,
} from "drizzle-orm/pg-core";
import { user } from "./auth";

export const idempotencyKeys = pgTable(
	"idempotency_keys",
	{
		id: text("id").primaryKey(),
		idempotencyKey: text("idempotency_key").notNull(),
		userId: text("user_id")
			.notNull()
			.references(() => user.id, { onDelete: "cascade" }),
		endpoint: text("endpoint").notNull(),
		responseStatus: integer("response_status").notNull(),
		responseBody: jsonb("response_body").notNull(),
		responseHash: text("response_hash").notNull(),
		createdAt: timestamp("created_at", {
			withTimezone: true,
			mode: "date",
		}).notNull(),
		expiresAt: timestamp("expires_at", {
			withTimezone: true,
			mode: "date",
		}).notNull(),
	},
	(t) => [
		uniqueIndex("idempotency_keys_user_key_endpoint_unique").on(
			t.userId,
			t.idempotencyKey,
			t.endpoint,
		),
		index("idempotency_keys_expires_at_idx").on(t.expiresAt),
	],
);
